<template>
	<div class="shelfpage">
		<div>
			<van-sticky>
				<div class="titleAble">
					<div class="titleAbleItem">
						<a href="#" @click="change('home')" :class="com_name == 'home' ? 'active' : ''"><span class="line" v-show="com_name == 'home'"></span>书架</a>
						<a href="#" @click="change('chunai')" :class="com_name == 'chunai' ? 'active' : ''"><span class="line" v-show="com_name == 'chunai'"></span>书单</a>
						<a href="#" @click="change('cp')" :class="com_name == 'cp' ? 'active' : ''"><span class="line" v-show="com_name == 'cp'"></span>关注</a>
					</div>

				</div>
			</van-sticky>
			<div class="btnTit" @click="jumpCjsd" v-if="com_name == 'chunai'">
				<img src="../assets/img/ellipsisBlack.png" alt="">
				<ul v-show="selectItem" class="select_item">
					<li v-for="(item,index) in selectItemList" @click="query_select(item.type,item.txt)" :class="queryIndex == item.type ? 'activeQuery' : ''">
						<span>{{item.txt}}</span>
						<img v-show="queryIndex == item.type ? true : false" src="../assets/img/query.png" alt="" />
					</li>
				</ul>
			</div>
			<div class="btnTit" @click="jumpCjsd01" v-if="com_name == 'home'">
				<img src="../assets/img/ellipsisBlack.png" alt="">
				<ul v-show="selectItemShelf" class="select_item">
					<li v-for="(item,index) in selectItemListShelf" @click="query_select01(item.type,item.txt)" :class="queryIndex == item.type ? 'activeQuery' : ''">
						<span>{{item.txt}}</span>
						<img v-show="queryIndex == item.type ? true : false" src="../assets/img/query.png" alt="" />
					</li>
				</ul>
			</div>
			<!-- <div class="btnTit" @click="jumpCjsd03" v-if="com_name == 'cp'">
				<img src="../assets/img/ellipsisBlack.png" alt="">
				<ul v-show="selectItemGz" class="select_item">
					<li v-for="(item,index) in selectItemListGz" @click="query_select03(item.type,item.txt)" :class="queryIndex == item.type ? 'activeQuery' : ''">
						<span>{{item.txt}}</span>
						<img v-show="queryIndex == item.type ? true : false" src="../assets/img/query.png" alt="" />
					</li>
				</ul>
			</div> -->
		</div>

		<!-- <bookshelfIndex v-if="com_name == 'home' ? true : false" :fmOrList="fmOrListFn"></bookshelfIndex>
		<bookby v-if="com_name == 'chunai' ? true : false" ref="child" @queryIndexbind="queryIndexbind"></bookby>
		<gz v-if="com_name == 'cp' ? true : false"></gz>
		<div style="height: 1.5rem"></div> -->
		<swiper class="swiper_tab01" :options="swiperOption_tab01" ref="mySwiper_book" style="height: calc(100vh - 4rem);overflow-y: scroll;">
			<swiper-slide :style="{position: activeId == 0 ? abs : 'relative'}">
				<bookshelfIndex v-if="com_name == 'home' ? true : false" :fmOrList="fmOrListFn" :fmOrListFnWjData="fmOrListFnWj" ref="child"></bookshelfIndex>
			</swiper-slide>
			<swiper-slide :style="{position: activeId == 1 ? abs : 'relative'}">
				<bookby v-if="com_name == 'chunai' ? true : false" ref="child" @queryIndexbind="queryIndexbind"></bookby>
			</swiper-slide>
			<swiper-slide :style="{position: activeId == 2 ? abs : 'relative'}">
				<gz v-if="com_name == 'cp' ? true : false" ref="child"></gz>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import bookshelfIndex from "@/views/bookshelf/bookshelfIndex";
	import bookby from "@/views/bookshelf/bookdy";
	import gz from "@/views/bookshelf/gz.vue"
	export default {
		components: {
			bookshelfIndex,
			bookby,
			gz
		},
		data() {
			const that = this
			return {
				com_name: 'home',
				selectItem: false,
				selectItemShelf: false,
				selectItemGz: false,
				selectItemList: [{
						txt: '创建书单',
						type: 1,
					}
					// ,
					// {
					// 	txt: '删除书单',
					// 	type: 2,
					// }
				],
				selectItemListShelf: [{
						txt: '封面',
						type: 1,//2
					},
					{
						txt: '列表',
						type: 2,//3
					},
					{
						txt: '按更新时间顺序',
						type: 3,//4
					},
					{
						txt: '按照收藏时间顺序',
						type: 4,//5
					},
					{
						txt: '按最近阅读排序',
						type: 5,//6
					},
					{
						txt: '显示全部',
						type: 6,//1
					},
					{
						txt: '只显示完结',
						type: 7,
					},
					{
						txt: '仅显示本地',
						type: 8, //4
					},
					{
						txt: '定制收藏',
						type: 9, //5
					},
				],
				selectItemListGz: [{
					txt: '删除关注',
					type: 1,
				}, ],
				queryIndex: 5,
				fmOrListFn: 6,
				fmOrListFnWj:'',
				list: [{
						component: bookshelfIndex,
					},
					{
						component: bookby,
					},
					{
						component: gz,
					}
				],
				swiperOption_tab01: {
					spaceBetween: 30,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					threshold : 50,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_book.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex')
							that.$emit('slideTab', swiper.activeIndex)
							that.abs = 'relative';
							if (swiper.activeIndex == 0) {
								that.com_name = 'home';
							} else if (swiper.activeIndex == 1) {
								that.com_name = 'chunai';
							} else if (swiper.activeIndex == 2) {
								that.com_name = 'cp';
							}
						},
					},
				},
				abs: 'relative',
				activeId: 0,
			}
		},
		computed: {
			// 定义swiper，在下面就可以引用这个swiper了；
			swiper: function() {
				return this.$refs.mySwiper_book.$swiper
			},
		},
		created() {
			if (this.$route.query.com_name == 'cp') {
				this.abs = 'absolute'
			} else if (this.$route.query.com_name == 'chunai') {
				this.abs = 'absolute'
			} else {
				this.abs = 'relative'
			}
			this.activeId = this.$route.query.active || 0;
			this.com_name = this.$route.query.com_name || 'home';
			this.queryIndex = localStorage.getItem('fmOrListFn');

			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
			change(data) {
				this.com_name = data;
				this.abs = 'relative';
				if (this.selectItem) {
					this.selectItem = false;
				} else if (this.selectItemShelf) {
					this.selectItemShelf = false;
				} else if (this.selectItemGz) {
					this.selectItemGz = false;
				}
				if (data == 'home') {
					this.swiper.slideTo(0, 0, false)
				} else if (data == 'chunai') {
					this.swiper.slideTo(1, 0, false)
				} else if (data == 'cp') {
					this.swiper.slideTo(2, 0, false)
				}

				if (!localStorage.getItem('fmOrListFn')) {
					this.queryIndex = 0;
				}
			},
			jumpCjsd() {
				this.abs = 'relative';
				if (this.selectItem) {
					this.selectItem = false;
				} else {
					this.selectItem = true;
				}
			},
			jumpCjsd01() {
				this.abs = 'relative';
				if (this.selectItemShelf) {
					this.selectItemShelf = false;
				} else {
					this.selectItemShelf = true;
				}
			},
			jumpCjsd03() {
				this.abs = 'relative';
				if (this.selectItemGz) {
					this.selectItemGz = false;
				} else {
					this.selectItemGz = true;
				}
			},
			query_select(index, txt) {
				var _t = this;
				_t.queryIndex = index;
				_t.selectItem = !_t.selectItem;
				if (index == 1) {
					// 跳转到创建书单页面
					_t.$router.push({
						path: '/cjsd',
						query: {
							bookshelfPage: 'bookshelfPageUrl'
						}
					});
				} else {
					_t.$refs.child.showDelbtn();
					setTimeout(function() {
						_t.selectItem = false;
					}, 100)
				}
			},
			query_select01(index, txt) {
				var _t = this;
				_t.queryIndex = index;
				_t.selectItem = !_t.selectItem;
				if (index == 1) {
					this.fmOrListFn = 1;
					localStorage.setItem('fmOrListFn', 1);
				} else if (index == 2) {
					this.fmOrListFn = 2;
					localStorage.setItem('fmOrListFn', 2);
				} else if (index == 3) {
					this.fmOrListFnWj = 3;
					localStorage.setItem('fmOrListFnWj', 3);
				} else if (index == 4) {
					this.fmOrListFnWj = 4;
					localStorage.setItem('fmOrListFnWj', 4);
				}else if (index == 5) {
					this.fmOrListFnWj = 5;
					localStorage.setItem('fmOrListFnWj', 5);
				}else if (index == 8) {
					this.fmOrListFnWj = 8;
					localStorage.setItem('fmOrListFnWj', 8);
				} else if (index == 6) {
					this.fmOrListFnWj = 6;
					localStorage.setItem('fmOrListFnWj', 6);
				} else if (index == 9) {
					this.fmOrListFnWj = 9;
					localStorage.setItem('fmOrListFnWj', 9);
				} else if (index == 7) {
					this.fmOrListFnWj = 7;
					localStorage.setItem('fmOrListFnWj', 7);
				}
				// _t.$refs.child.fmOrListchild(index)
			},
			query_select03(index, txt) {
				var _t = this;
				_t.queryIndex = index;
				_t.selectItem = !_t.selectItem;
				_t.$refs.child.showCollect();
			},
			queryIndexbind(params) {
				this.queryIndex = params;
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.van-tabbar-item--active {
		color: #ff4081 !important;
	}

	.shelfpage {
		// height: 100vh;
		background-color: #fff;

		// overflow-y: scroll;
		.titleAble {
			height: 160px;
			display: flex;
			position: relative;
			border-bottom: 1px solid #f0f0f0;
			// background: url(../assets/img/jin.png) no-repeat 7% 60px;
			// background-size: 19.5%;
			background: url(../assets/img/myicon/indexBgc03.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;

			.titleAbleItem {
				height: 90px;
				display: flex;
				// justify-content: space-around;
				width: calc(100vw - 40vw);
				padding: 0px 40px;
				margin: 0 auto;
				margin-top: 70px;

				a {
					flex: 1;
					text-align: center;
					display: inline-block;
					// color: #ff4c89;
					color: #000;
					font-size: 32px;
					/*px*/
					position: relative;
					padding: 10px 20px;

					.line {
						width: 72px;
						height: 6px;
						background-color: #ff4089;
						display: block;
						position: absolute;
						bottom: 6px;
						left: 50%;
						transform: translateX(-50%);
						border-radius: 2px;
					}
				}

				.active {
					transform: scale(1.2);
					font-weight: 600;
					color: #ff4089;
				}
			}


		}

		.btnTit {
			padding: 0;
			position: fixed;
			top: 105px;
			right: 20px;
			transform: translateY(-50%);
			z-index: 999;

			img {
				width: 55px;
			}

			.select_item {
				width: 260px;
				z-index: 9;
				// background-color: rgba(0,0,0,.05);
				// border-radius: 5px;
				line-height: 56px;
				padding: 5px 20px;
				box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .3);
				/*no*/
				position: absolute;
				right: 0px;
				top: 58px;
				background: #fff;

				li {
					color: #9A9A9A;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 28px;

					img {
						width: 30px;
					}
				}
			}
		}
	}
</style>
